<template>
  <v-card class="d-flex flex-column" style="height: 100vh">
    <v-card-title class="primary white--text d-flex align-center flex-shrink-0">
      <v-icon dark left>mdi-towel</v-icon>
      TDOT Wettbewerb
      <v-spacer></v-spacer>
      <v-btn icon dark @click="$emit('close')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-tabs style="flex: none" centered v-model="tab">
      <v-tab>
        <v-icon left>mdi-account-plus-outline</v-icon>
        Alibey
      </v-tab>
      <v-tab>
        <v-badge color="error" :content="mikrofaserPendingCount" :value="mikrofaserPendingCount > 0" overlap>
          <v-icon left>mdi-towel</v-icon>
          Mikrofaser
        </v-badge>
      </v-tab>
    </v-tabs>

    <v-card-text class="pa-0" style="overflow-y: auto; flex-grow: 1">
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <v-container fluid class="pa-4 d-flex flex-column">
            <div v-if="!isAlibeyListVisible" class="flex-grow-1 d-flex flex-column justify-center align-center text-center">
              <v-icon size="100" color="primary lighten-2">mdi-account-group-outline</v-icon>

              <div class="grey--text text--darken-2 mt-4" style="font-size: 1.25rem; font-weight: 500">Teilnehmer (Alibey Wettbewerb)</div>

              <div class="display-3 font-weight-bold primary--text" style="line-height: 1.1; font-size: 6rem !important">
                <v-progress-circular v-if="loadingAlibey && displayAlibeyCount === 0" indeterminate color="primary"></v-progress-circular>
                <span v-else>{{ Math.floor(displayAlibeyCount) }}</span>
              </div>

              <p class="body-2 grey--text text--darken-2 mt-6 px-4" style="max-width: 500px">
                Hier werden alle Besucher erfasst, die am grossen TDOT-Wettbewerb teilnehmen.
              </p>

              <v-tooltip bottom :disabled="!$moment().isBefore(startDate)">
                <template v-slot:activator="{ on }">
                  <div v-on="on" class="mt-4">
                    <v-btn :disabled="$moment().isBefore(startDate)" color="primary" @click="openAddLeadDialog" x-large rounded elevation="2">
                      <v-icon left>mdi-plus</v-icon>
                      Teilnehmer hinzufügen
                    </v-btn>
                  </div>
                </template>
                <span>Erfassung erst ab 01.11. möglich</span>
              </v-tooltip>

              <v-spacer></v-spacer>

              <v-btn text color="grey darken-1" @click="isAlibeyListVisible = true" class="mb-4 mt-5" :disabled="loadingAlibey">
                <v-icon left>mdi-format-list-bulleted</v-icon>
                Teilnehmerliste anzeigen
              </v-btn>
            </div>

            <div v-else>
              <v-btn text @click="isAlibeyListVisible = false" class="mb-2">
                <v-icon left>mdi-chevron-left</v-icon>
                Zurück zur Übersicht
              </v-btn>

              <v-card-actions class="pa-0 mb-4">
                <v-spacer></v-spacer>
                <v-tooltip bottom :disabled="!$moment().isBefore(startDate)">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-btn :disabled="$moment().isBefore(startDate)" color="primary" @click="openAddLeadDialog" rounded elevation="2">
                        <v-icon left>mdi-plus</v-icon>
                        Teilnehmer hinzufügen
                      </v-btn>
                    </div>
                  </template>
                  <span>Erfassung erst ab 01.11. möglich</span>
                </v-tooltip>
              </v-card-actions>

              <v-row class="mb-4" align="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="searchAlibey"
                    label="Alibey Leads suchen (Name, E-Mail, Telefon...)"
                    prepend-inner-icon="mdi-magnify"
                    dense
                    hide-details
                    clearable
                    outlined
                    rounded></v-text-field>
                </v-col>
              </v-row>

              <v-data-table
                :headers="headersAlibey"
                :items="filteredAlibeyLeads"
                :items-per-page="10"
                class="elevation-1 rounded-lg"
                :loading="loadingAlibey"
                loading-text="Lade Alibey Leads..."
                :no-data-text="'Keine Leads für Alibey gefunden.'"
                :no-results-text="'Keine Leads für diese Suche gefunden.'">
                <template v-slot:item.customerName="{ item }">
                  <div class="d-flex align-center py-2">
                    <v-avatar color="primary" size="36" class="white--text mr-4">
                      <span class="font-weight-bold">{{ getInitials(item.customerName) }}</span>
                    </v-avatar>
                    <div>
                      <div class="font-weight-bold">{{ item.surname }} {{ item.name }}</div>
                      <div class="text-caption grey--text">{{ item.email }}</div>
                    </div>
                  </div>
                </template>
                <template v-slot:item.contact="{ item }">
                  <div v-if="item.phone">{{ item.phone }}</div>
                </template>
                <template v-slot:item.createdAt="{ item }">
                  {{ formatDate(item.createdAt) }}
                </template>
                <template v-slot:item.address="{ item }">
                  <div v-if="item.street || item.city" class="py-2">
                    <div class="text-caption">{{ item.street }}</div>
                    <div class="text-caption">{{ item.plz }} {{ item.city }}</div>
                  </div>
                </template>

                <template v-slot:item.referral="{ item }">
                  <div v-if="item.referralSource" class="text-caption">
                    {{ item.referralSource }}
                    <span v-if="item.referralSource === 'Andere' && item.referralSourceOther"> : {{ item.referralSourceOther }} </span>
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-container>
        </v-tab-item>

        <v-tab-item>
          <v-container fluid class="pa-4">
            <div class="mb-4 pa-3 rounded-lg" style="background-color: #f5f5f5">
              <h3 class="subtitle-1 font-weight-bold">
                <v-icon left color="primary">mdi-gift-outline</v-icon>
                Mikrofaser-Tuch Aktion (Landingpage)
              </h3>
              <p class="body-2 grey--text text--darken-2 mb-0">Markiere das Tuch als 'abgeholt', sobald es übergeben wurde.</p>
            </div>

            <v-row class="mb-2" align="center">
              <v-col cols="12" md="7">
                <v-text-field
                  v-model="searchMikrofaser"
                  label="Mikrofaser Leads suchen..."
                  prepend-inner-icon="mdi-magnify"
                  dense
                  hide-details
                  clearable
                  outlined
                  rounded></v-text-field>
              </v-col>
              <v-col cols="12" md="5">
                <v-switch v-model="showOnlyPending" label="Nur offene anzeigen" dense hide-details class="mt-0 pt-0"></v-switch>
              </v-col>
            </v-row>

            <div v-if="loadingMikrofaser" class="text-center pa-8">
              <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
              <div class="mt-4 grey--text">Lade Mikrofaser Leads...</div>
            </div>

            <v-list two-line class="pa-0" v-else>
              <div v-if="!filteredMikrofaserLeads.length" class="text-center pa-8 grey--text text--lighten-1">
                <v-icon size="80" color="grey lighten-2">mdi-towel</v-icon>
                <p class="mt-4 headline" style="line-height: 1.5rem">
                  <span v-if="searchMikrofaser">Keine Leads für diese Suche gefunden.</span>
                  <span v-else-if="!showOnlyPending">Keine Leads vorhanden.</span>
                  <span v-else>Alle Tücher wurden abgeholt! 🎉</span>
                </p>
              </div>

              <div v-for="item in filteredMikrofaserLeads" :key="item._id" class="list-item-card">
                <v-list-item>
                  <v-list-item-avatar color="primary" size="48" class="white--text">
                    <span class="title ma-auto">{{ getInitials(item.customerName) }}</span>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title class="font-weight-bold">{{ item.customerName }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.email">{{ item.email }}</v-list-item-subtitle>
                    <v-list-item-subtitle v-if="item.phone">{{ item.phone }}</v-list-item-subtitle>
                  </v-list-item-content>

                  <v-list-item-action>
                    <v-btn
                      v-if="item.notes !== 'tuch abgeholt'"
                      fab
                      depressed
                      color="success"
                      :loading="item.loading"
                      @click="markTowelPickedUp(item)"
                      class="action-button">
                      <v-icon>mdi-check</v-icon>
                    </v-btn>
                    <v-chip v-else color="grey" small dark label class="mr-2">
                      <v-icon left small>mdi-check-all</v-icon>
                      Abgeholt
                    </v-chip>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
              </div>
            </v-list>
          </v-container>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>

    <v-dialog max-width="500px" v-model="addLeadDialog" persistent>
      <v-card>
        <v-card-title class="primary white--text"> <v-icon left dark>mdi-account-plus</v-icon> Neuer Wettbewerb Eintrag </v-card-title>
        <v-card-text class="pt-6">
          <v-form ref="addLeadForm" v-model="addLeadFormValid">
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field label="Vorname*" filled v-model="newLead.surname" :rules="[rules.required]" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field label="Name*" filled v-model="newLead.name" :rules="[rules.required]" dense></v-text-field>
              </v-col>
            </v-row>
            <v-text-field label="E-Mail" filled v-model="newLead.email" :rules="[rules.emailFormat]" dense></v-text-field>
            <v-text-field label="Telefon*" filled v-model="newLead.phone" :rules="[rules.required]" dense></v-text-field>
            <v-text-field label="Strasse*" filled v-model="newLead.street" :rules="[rules.required]" dense></v-text-field>
            <v-row>
              <v-col cols="12" sm="6">
                <v-text-field label="PLZ*" filled v-model="newLead.plz" :rules="[rules.required]" dense></v-text-field>
              </v-col>
              <v-col cols="12" sm="6">
                <v-text-field label="Ort*" filled v-model="newLead.city" :rules="[rules.required]" dense></v-text-field>
              </v-col>
            </v-row>
            <v-select
              label="Wie wurden Sie auf uns aufmerksam?*"
              :items="referralOptions"
              v-model="newLead.referralSource"
              :rules="[rules.required]"
              filled
              dense
              hide-details="auto"
              class="mb-2"></v-select>
            <v-text-field
              v-if="newLead.referralSource === 'Andere'"
              label="Andere (bitte angeben)*"
              v-model="newLead.referralSourceOther"
              :rules="[rules.requiredIfOther]"
              outlined
              dense
              class="mt-4"></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-spacer></v-spacer> <v-btn text @click="addLeadDialog = false">Abbrechen</v-btn>
          <v-btn color="primary" @click="saveNewLead" :loading="savingLead" :disabled="!addLeadFormValid || savingLead" large elevation="2">
            Speichern
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>
<script>
import api from "@/api"
import { mapGetters } from "vuex"

export default {
  name: "TdotCompetition",
  data() {
    return {
      tab: null, // Aktiver Tab
      startDate: "2025-11-01",
      mikrofaserPendingCount: 0,
      isAlibeyListVisible: false, // NEU: Standardmässig auf false
      displayAlibeyCount: 0, // NEU: Für den animierten Zähler
      showOnlyPending: true,
      // Data & Status für Alibey
      alibeyLeads: [],
      loadingAlibey: true,
      searchAlibey: "",
      headersAlibey: [
        { text: "Kunde", value: "customerName", sortable: true, width: "30%" },
        { text: "Telefon", value: "contact", sortable: false, width: "15%" },
        // NEU
        { text: "Adresse", value: "address", sortable: false, width: "25%" },
        // NEU (ersetzt 'notes')
        { text: "Quelle", value: "referral", sortable: true }, // 'referral' ist ein "virtueller" Slot
        { text: "Erstellt am", value: "createdAt", sortable: true },
      ],

      // Data & Status für Mikrofaser
      mikrofaserLeads: [],
      loadingMikrofaser: true,
      searchMikrofaser: "",

      // Für den "Lead hinzufügen" Dialog
      addLeadDialog: false,
      savingLead: false,
      // NEU: Optionen für das Dropdown
      referralOptions: ["Bestehendes Mitglied", "Inserat", "Flyer im Briefkasten", "Social Media Werbung", "Andere"],

      // NEU: Status der Formularvalidierung
      addLeadFormValid: false,

      // NEU: Validierungsregeln
      rules: {
        required: (value) => !!value || "Dieses Feld ist erforderlich.",
        requiredIfOther: (value) => {
          // Nur prüfen, wenn 'Andere' ausgewählt ist
          if (this.newLead.referralSource === "Andere") {
            return !!value || "Bitte angeben."
          }
          return true // Sonst immer gültig
        },
        emailFormat: (value) => {
          // Optional, aber WENN, dann valides Format
          if (!value) return true
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || "Ungültige E-Mail-Adresse."
        },
      },
      newLead: {
        name: "",
        surname: "",
        email: "",
        phone: "",
        // NEU: Felder für die Herkunft
        referralSource: null,
        referralSourceOther: "",
        // 'note' entfernt, wird jetzt generiert
      },
    }
  },

  computed: {
    ...mapGetters([]),

    filteredAlibeyLeads() {
      if (!this.searchAlibey || this.searchAlibey.trim() === "") {
        return this.alibeyLeads
      }
      const search = this.searchAlibey.toLowerCase().trim()
      return this.alibeyLeads.filter((lead) => {
        const fullName = (lead.customerName || "").toLowerCase()
        const email = (lead.email || "").toLowerCase()
        const phone = (lead.phone || "").toLowerCase()

        // NEUE FELDER ZUR SUCHE HINZUFÜGEN
        const street = (lead.street || "").toLowerCase()
        const city = (lead.city || "").toLowerCase()
        const plz = (lead.plz || "").toLowerCase()
        const referral = (lead.referralSource || "").toLowerCase()
        const referralOther = (lead.referralSourceOther || "").toLowerCase()

        return (
          fullName.includes(search) ||
          email.includes(search) ||
          phone.includes(search) ||
          street.includes(search) ||
          city.includes(search) ||
          plz.includes(search) ||
          referral.includes(search) ||
          referralOther.includes(search)
        )
      })
    },

    filteredMikrofaserLeads() {
      let leads = this.mikrofaserLeads

      if (this.showOnlyPending) {
        leads = leads.filter((lead) => lead.notes !== "tuch abgeholt")
      }

      if (!this.searchMikrofaser || this.searchMikrofaser.trim() === "") {
        return leads
      }
      const search = this.searchMikrofaser.toLowerCase().trim()
      return leads.filter((lead) => {
        const fullName = (lead.customerName || "").toLowerCase()
        const email = (lead.email || "").toLowerCase()
        const phone = (lead.phone || "").toLowerCase()
        return fullName.includes(search) || email.includes(search) || phone.includes(search)
      })
    },
  },

  created() {
    this.fetchLeadsFromCompetition("alibey")
    this.fetchLeadsFromCompetition("mikrofaser")
  },

  methods: {
    /**
     * NEU: Helper-Methode für die Avatare
     */
    getInitials(name) {
      if (!name) return "?"
      const parts = name.trim().split(" ")
      const surnameInitial = parts[0] ? parts[0][0] : ""
      const nameInitial = parts.length > 1 ? parts[parts.length - 1][0] : ""

      let initials = surnameInitial
      if (nameInitial && nameInitial !== surnameInitial) {
        initials += nameInitial
      }

      if (initials.length === 1 && name.length > 1) {
        initials = name.substring(0, 2)
      }

      return initials.toUpperCase()
    },

    /**
     * NEU: Die "SICK" Zähler-Animation
     */
    tweenCount(targetValue) {
      const startValue = this.displayAlibeyCount
      // Wenn sich nichts ändert (z.B. bei schnellem Tab-Wechsel), nicht animieren
      if (startValue === targetValue && !this.loadingAlibey) return

      const duration = 1000 // 1 Sekunde Animation
      let startTime = null

      const animate = (currentTime) => {
        if (!startTime) startTime = currentTime
        const progress = Math.min((currentTime - startTime) / duration, 1)

        // Cubic Ease-Out (startet schnell, bremst sanft)
        const easeOutProgress = 1 - Math.pow(1 - progress, 3)

        const currentValue = Math.floor(easeOutProgress * (targetValue - startValue) + startValue)
        this.displayAlibeyCount = currentValue

        if (progress < 1) {
          requestAnimationFrame(animate)
        } else {
          this.displayAlibeyCount = targetValue // Am Ende exakten Wert setzen
        }
      }
      requestAnimationFrame(animate)
    },

    /**
     * Lädt Leads basierend auf dem Kampagnennamen.
     */
    async fetchLeadsFromCompetition(campaignName) {
      if (campaignName === "alibey") {
        this.loadingAlibey = true
      } else {
        this.loadingMikrofaser = true
      }

      try {
        const leads = await api.fetchCampaignLeads(campaignName)

        const leadsWithProps = leads.map((lead) => ({
          ...lead,
          loading: false,
          customerName: `${lead.surname || ""} ${lead.name || ""}`.trim(),
        }))

        if (campaignName === "alibey") {
          this.alibeyLeads = leadsWithProps
          // NEU: Animation des Zählers nach dem Laden auslösen
          this.tweenCount(leadsWithProps.length)
        } else {
          this.mikrofaserLeads = leadsWithProps
          this.mikrofaserPendingCount = leads.filter((lead) => lead.notes !== "tuch abgeholt").length
        }
      } catch (e) {
        console.error(`Fehler beim Laden der ${campaignName} Leads:`, e)
        this.$toast.error(`Fehler beim Laden der ${campaignName} Leads.`)
      } finally {
        if (campaignName === "alibey") {
          this.loadingAlibey = false
        } else {
          this.loadingMikrofaser = false
        }
      }
    },

    /**
     * Öffnet den Dialog zum Hinzufügen eines neuen Alibey-Leads.
     */
    openAddLeadDialog() {
      // NEU: Felder zurücksetzen
      this.newLead = {
        name: "",
        surname: "",
        email: "",
        phone: "",
        street: "", // Hinzugefügt
        plz: "", // Hinzugefügt
        city: "", // Hinzugefügt
        referralSource: null,
        referralSourceOther: "",
      }
      if (this.$refs.addLeadForm) {
        this.$refs.addLeadForm.resetValidation()
      }
      this.addLeadDialog = true
    },

    /**
     * Speichert den neuen Lead (Alibey).
     */
    async saveNewLead() {
      if (!this.$refs.addLeadForm.validate()) {
        this.$toast.error("Bitte alle Pflichtfelder (*) korrekt ausfüllen.")
        return
      }
      this.savingLead = true
      try {
        const payload = {
          name: this.newLead.name,
          surname: this.newLead.surname,
          email: this.newLead.email,
          phone: this.newLead.phone,

          // HIER DIE NEUEN FELDER HINZUFÜGEN
          street: this.newLead.street,
          plz: this.newLead.plz,
          city: this.newLead.city,

          // NEUE REFERRAL-FELDER
          referralSource: this.newLead.referralSource,
          referralSourceOther: this.newLead.referralSource === "Andere" ? this.newLead.referralSourceOther : "", // Nur speichern, wenn 'Andere' gewählt ist

          type: "68fb50c6072f8022b746d856", // <-- BITTE ANPASSEN
          campaignName: "alibey",
        }

        await api.createWalkin(payload)
        this.$toast.success("Lead erfolgreich hinzugefügt.")
        this.addLeadDialog = false
        // NEU: Lädt die Liste neu. fetchLeads... löst dann automatisch
        // die Zähler-Animation aus.
        await this.fetchLeadsFromCompetition("alibey")
      } catch (e) {
        console.error("Fehler beim Speichern des Leads:", e)
        this.$toast.error("Fehler beim Speichern des Leads.")
      } finally {
        this.savingLead = false
      }
    },

    /**
     * Markiert ein Mikrofaser-Tuch als abgeholt.
     */
    async markTowelPickedUp(lead) {
      this.$set(lead, "loading", true)
      try {
        const updatedLead = { ...lead, notes: "tuch abgeholt" }
        await api.updateLead(updatedLead)
        this.$toast.success(`Tuch für ${lead.customerName} als abgeholt markiert.`)

        const index = this.mikrofaserLeads.findIndex((l) => l._id === lead._id)
        if (index > -1) {
          updatedLead.loading = false
          this.$set(this.mikrofaserLeads, index, updatedLead)
          this.mikrofaserPendingCount = this.mikrofaserLeads.filter((l) => l.notes !== "tuch abgeholt").length
        }
      } catch (e) {
        console.error("Fehler beim Aktualisieren des Leads:", e)
        this.$toast.error("Fehler beim Aktualisieren des Leads.")
        this.$set(lead, "loading", false)
      }
    },

    /**
     * Formatiert ein ISO-Datum oder einen Timestamp.
     */
    formatDate(isoString) {
      if (!isoString) return "-"
      return this.$moment(isoString).format("DD.MM.YYYY, HH:mm")
    },
  },
}
</script>

<style lang="scss" scoped>
/* Style für den "Feed"-Look im Mikrofaser-Tab */
.list-item-card {
  border: 1px solid #eee;
  border-radius: 12px;
  margin-bottom: 8px;
  background: #fff;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: #ddd;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
  }
}

.action-button {
  margin-right: -4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
}

/* Sorgt dafür, dass die v-list nicht den Standard-Padding der v-card-text überschreibt */
.v-card__text {
  .v-tabs-items {
    .container {
      /* Wichtig für die Alibey-Zähler-Ansicht */
      &.d-flex {
        padding: 16px !important;
      }
    }
  }
}

/* Stellt sicher, dass der Tab-Inhalt die volle Höhe einnimmt */
.v-tabs-items,
.v-tab-item {
  // height: 100%;
}
</style>
